module.exports = __webpack_public_path__ + "img/res4.7d1753c2.jpg";